import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, BookOpen, ClipboardList, CheckSquare, Users, HelpCircle, Clock } from 'lucide-react';

function StaffHome({ user, onLogout }) {
  const navigate = useNavigate();

  const menuOptions = [
    {
      title: 'Batch Recipes',
      description: 'View and scale batch preparation recipes',
      icon: BookOpen,
      path: '/batch-recipes',
      color: 'from-purple-600 to-purple-400',
      testId: 'batch-recipes-option'
    },
    {
      title: 'Assembly SOPs',
      description: 'Bowl, smoothie, and savory assembly guides',
      icon: ClipboardList,
      path: '/assembly-sops',
      color: 'from-blue-600 to-blue-400',
      testId: 'assembly-sops-option'
    },
    {
      title: 'Batch History',
      description: 'View and update batch preparation records',
      icon: Clock,
      path: '/batches',
      color: 'from-indigo-600 to-indigo-400',
      testId: 'batch-history-option'
    },
    {
      title: 'Opening/Closing Checklist',
      description: 'Daily opening and closing procedures',
      icon: CheckSquare,
      path: '/checklists',
      color: 'from-green-600 to-green-400',
      testId: 'checklists-option'
    },
    {
      title: 'Customer Interaction SOP',
      description: 'Customer service workflow and guidelines',
      icon: Users,
      path: '/customer-sop',
      color: 'from-orange-600 to-orange-400',
      testId: 'customer-sop-option'
    },
    {
      title: 'FAQs',
      description: 'Frequently asked questions and answers',
      icon: HelpCircle,
      path: '/faqs',
      color: 'from-pink-600 to-pink-400',
      testId: 'faqs-option'
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-white to-primary/5">
      {/* Header */}
      <header className="glass border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="/acai-theory-logo.png" 
              alt="Acai Theory" 
              className="h-10 w-auto"
            />
            <div>
              <p className="text-xs text-gray-500">@{user.username}</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onLogout}
            data-testid="logout-button"
            className="rounded-xl"
          >
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Staff Portal</h1>
          <p className="text-gray-600">Select an option to get started</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {menuOptions.map((option) => {
            const Icon = option.icon;
            return (
              <div
                key={option.path}
                onClick={() => navigate(option.path)}
                data-testid={option.testId}
                className="bg-white rounded-2xl p-6 shadow-md border-2 border-gray-100 hover:border-primary/30 hover-lift cursor-pointer transition-all"
              >
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${option.color} flex items-center justify-center mb-4`}>
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{option.title}</h3>
                <p className="text-sm text-gray-600">{option.description}</p>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}

export default StaffHome;